// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Row, Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { evalDateHour } from '../utils/enUtils.js'

export class Profile extends Component {
    constructor(props) {
        super(props)

        this.data = this.props.appData
        this.hidden = { display: 'none' }
        this.visible = { display: 'block' }
        this.linkDisabled = { pointerEvent: 'none', cursor: 'default' }
        this.linkEnabled = { pointerEvent: 'auto', cursor: 'pointer' }

        this.path = {
            rating: '/assets/images/Ratings/',
            modules: '/assets/images/Modules/',
            webgl: 'http://webgl.enablerinteractive.com/',
            platforms: '/assets/images/Platforms/',
            instructions: '/assets/images/Instructions/'
        }

        this.state = {
            showAndroidModal: false,
            showIosModal: false,
            androidIcon: 'inactive',
            iosIcon: 'inactive'
        }

        this.evalRatingIcon = this.evalRatingIcon.bind(this)
        this.openAndroidInstructions = this.openAndroidInstructions.bind(this)
        this.closeAndroidInstructions = this.closeAndroidInstructions.bind(this)
        this.openIosInstructions = this.openIosInstructions.bind(this)
        this.closeIosInstructions = this.closeIosInstructions.bind(this)
    }

    openAndroidInstructions() {
        console.log("Android")
        this.setState({
            showAndroidModal: true,
            androidIcon: 'active'
        })
    }

    closeAndroidInstructions() {
        this.setState({
            showAndroidModal: false,
            androidIcon: 'inactive'
        })
    }

    openIosInstructions() {
        console.log("ios")
        this.setState({
            showIosModal: true,
            iosIcon: 'active'
        })
    }

    closeIosInstructions() {
        this.setState({
            showIosModal: false,
            iosIcon: 'inactive'
        })
    }

    get androidModal() {
        return (
            <Modal show={this.state.showAndroidModal} onHide={this.closeAndroidInstructions} onExited={this.closeAndroidInstructions} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h2">Android Device Setup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="step">
                        <h3><b>Step 1:</b> Open your google play store on your Android device</h3>
                        <div className="image screenshot">
                            <img src={this.path.instructions + "step1.jpg"} alt="Step 1" />
                        </div>
                    </div>
                    <div className="step">
                        <h3><b>Step 2:</b> Search for an application called 'Enabler (alpha)'</h3>
                        <div className="image screenshot">
                            <img src={this.path.instructions + "step2.png"} alt="Step 2" />
                        </div>
                    </div>
                    <div className="step">
                        <h3><b>Step 3:</b> Install the Enabler (Alpha) (unreleased) application</h3>
                        <div className="image screenshot">
                            <img src={this.path.instructions + "step3.png"} alt="Step 3" />
                        </div>
                    </div>
                    <div className="step">
                        <h3><b>Step 4:</b> Locate the application on your device then you can use the same login information as this website to log into the Enabler application.</h3>
                        <div className="image screenshot">
                            <img src={this.path.instructions + "step4.png"} alt="Step 4" />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.closeAndroidInstructions}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    get iosModal() {
        return (
            <Modal show={this.state.showIosModal} onHide={this.closeIosInstructions} onExited={this.closeIosInstructions} bsSize="large" >
                <Modal.Header closeButton>
                    <Modal.Title componentClass="h2">IOS Device Setup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>The application for your device will be ready soon! Please use the 'Launch in browser' option for now to start training.</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.closeIosInstructions}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    evalRatingIcon(strikes, size) {
        switch (Math.round(strikes)) {
            case 0: return this.path.rating + size + '/Icon_Badge_excellent.png'
            case 1: return this.path.rating + size + '/Icon_Badge_good.png'
            case 2: return this.path.rating + size + '/Icon_Badge_pass.png'
            case 3: return this.path.rating + size + '/Icon_Badge_failed.png'
            default: return ''
        }
    }

    get workerProfileInfo() {

        let markUp = (<section className="user-info left-panel"></section>)

        if (typeof this.worker !== 'undefined') {

            let ageInfo = '', genderInfo = '', emailInfo = ''
            let iosIcon = '', androidIcon = '', platformIconPanel = ''
            let ratingStyle = this.hidden

            if (this.worker.average_strikes !== null) {
                ratingStyle = this.worker.average_strikes === null ? this.hidden : this.visible
            }

            if (this.worker.gender !== null && this.worker.gender !== "") {
                genderInfo = <div><span>Gender:<br /> {this.worker.gender}</span></div>
            }

            if (this.worker.email !== null && this.worker.email !== "") {
                emailInfo = <div><span>Email:<br /> {this.worker.email}</span></div>
            }

            let vitalStats = (
                <div className="vital-stats">
                    {ageInfo}
                    {genderInfo}
                    {emailInfo}
                    <div><span>Last Active: <br /> {evalDateHour(new Date(this.worker.last_active_at))} </span></div>
                </div>
            )

            if (this.data.profileType === 'worker') {
                androidIcon = (
                    <div className="android">
                        <img src={this.path.platforms + "Icon_Android_" + this.state.androidIcon + ".png"} alt="android app instructions" onClick={this.openAndroidInstructions} />
                        {this.androidModal}
                    </div>
                )

                iosIcon = (
                    <div className="ios">
                        <img src={this.path.platforms + "Icon_Ios_" + this.state.iosIcon + ".png"} alt="ios app instructions" onClick={this.openIosInstructions} />
                        {this.iosModal}
                    </div>
                )

                platformIconPanel = (
                    <Row className="platforms-icon-panel">
                        <p>Launch the training scenarios on your mobile device. Click on a platform icon (Apple or Android) for instructions:</p>
                        <Col sm={6} xs={6}>
                            {androidIcon}
                        </Col>
                        <Col sm={6} xs={6}>
                            {iosIcon}
                        </Col>
                    </Row>
                )
            }

            markUp = (
                <section className="user-info left-panel">
                    <h3 className="user-title title">
                        {this.worker.first_name} <br />
                        {this.worker.last_name}
                    </h3>
                    <div className="rating" style={ratingStyle}>
                        <img src={this.evalRatingIcon(this.worker.average_strikes, 'Large')} alt="rating" />
                    </div>
                    {vitalStats}
                    {platformIconPanel}
                </section>
            )
        }

        return markUp
    }

    getScenarios(scenarios, moduleId) {
        if (scenarios.length === 0) {
            return (
                <Row bsClass="scenario row">
                    <div className="info">
                        <Col sm={6} bsClass="info-container col">
                            <div className="image">
                                <img src={this.path.modules + 'Icon_Scenario_Development.png'} alt='Comming Soon' />
                                <h4 className="scenario-name name">Coming Soon</h4>
                            </div>
                        </Col>
                    </div>
                </Row>
            )
        }

        return scenarios.map((scenario, index) => {
            let link = "/dashboard/profile/module?id=" + moduleId + "&worker=" + this.props.location.query.userId
            let image = this.path.modules + scenario.module + "/Icon_Scenario_" + scenario.name + ".png"
            let rating = this.evalRatingIcon(scenario.strikes, 'Large')
            let webgl = this.path.webgl + scenario.module + "/" + scenario.name
            let launchStyle = (this.data.profileType === 'provider') ? this.hidden : this.visible
            let emptyGameStyle = scenario.data.length === 0 ? this.hidden : this.visible

            return (
                <Row
                    key={index}
                    bsClass="scenario row"
                >
                    <div className="info">
                        <Col sm={6} bsClass="info-container col">
                            <div className="image">
                                <img src={image} alt={scenario.name} />
                                <h4 className="scenario-name name">{scenario.name}</h4>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className="rating" style={emptyGameStyle}>
                                <img src={rating} alt="rating" />
                            </div>

                            <label><Link to={link} >View details</Link></label>
                            <label style={launchStyle}><Link to={webgl} target="_blank" >Launch</Link></label>
                        </Col>
                    </div>
                </Row>
            )
        })
    }

    get modules() {
        let moduleItems = <Row></Row>

        if (typeof this.worker !== 'undefined') {

            return this.worker.modules.map((module, index) => {
                let link = module.scenarios.length === 0 ? null : "/dashboard/profile/module?id=" + index + "&worker=" + this.props.location.query.userId
                let moduleImage = this.path.modules + module.name + "/Icon_Module_" + module.name + ".png"
                let rating = this.evalRatingIcon(module.strikes, 'Small')
                let ratingStyle = module.strikes === null ? this.hidden : this.visible
                let linkStyle = module.scenarios.length === 0 ? this.linkDisabled : this.linkEnabled

                moduleItems = (
                    <Row key={index}>
                        <Col sm={3} smOffset={1} bsClass="module col">
                            <Link to={link} >
                                <div className="info" style={linkStyle}>
                                    <div className="module-image image">
                                        <img src={moduleImage} alt={module.name} />
                                        <div className="rating" style={ratingStyle}>
                                            <img src={rating} alt="rating" />
                                        </div>
                                    </div>
                                    <h4 className="module-name name">{module.name}</h4>
                                </div>
                            </Link>
                        </Col>
                        <Col sm={6} >
                            {this.getScenarios(module.scenarios, index)}
                        </Col>
                    </Row>

                )

                return moduleItems
            })
        }
    }

    componentWillMount() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    fname: storedData.fname,
                    lname: storedData.lname,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
            else {

                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    id: storedData.uid,
                    admin_first_name: storedData.fname,
                    admin_last_name: storedData.lname,
                    name: storedData.company,
                    address: storedData.address,
                    license_count: storedData.licenseCount,
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleProviderDataUpdateFromSessionStorage(data)
            }
        }
        else {
            if (this.data.profileType === 'worker') {
                this.props.getWorkerModulesFromApi()
            }
        }
    }

    render() {
        let rightPanel = ''
        this.data = this.props.appData
        this.worker = this.data.workers[this.props.location.query.userId]

        if (typeof this.worker !== 'undefined' && this.data.profileType === 'worker' && 'provider' in this.worker === false) {
            rightPanel = (
                <section className="module-list right-panel">
                    <Row className="message-panel">
                        <Col sm={12}>
                            <p>You have no available training scenarios to work on, please affiliate yourself to an organisation or <Link to='https://www.enablerinteractive.com/contact'>get in contact with us.</Link></p>
                        </Col>
                    </Row>
                </section>
            )
        }
        else if (typeof this.worker !== 'undefined' && this.data.profileType === 'provider' && this.worker.modules.length === 0) {
            rightPanel = (
                <section className="module-list right-panel">
                    <Row className="message-panel">
                        <Col sm={12}>
                            <p>{this.worker.first_name + ' ' + this.worker.last_name} is yet to try out a scenario.</p>
                        </Col>
                    </Row>
                </section>
            )
        }
        else {
            rightPanel = (
                <section className="module-list right-panel">
                    {this.modules}
                </section>
            )
        }

        let breadcrumb

        if (this.data.profileType === 'provider') {
            breadcrumb = (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)
        }

        let secsidebar, mainBodyStyle

        if (this.props.appData.profileType === 'provider') {
            secsidebar = (<SecSidebar
                profileType={this.props.appData.profileType}
                profile={0}
                menuItemsKey={"workforce"}
            />)

            mainBodyStyle = "main-body"
        }
        else {
            mainBodyStyle = "main-body-wide"
        }

        return (
            <div className="profile-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    active={1}
                />

                {secsidebar}

                <div className={mainBodyStyle}>
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                {breadcrumb}
                                <h2 className="title">Worker Profile</h2>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2} md={2} xs={2} smOffset={1} mdOffset={1} xsOffset={1}>
                            {this.workerProfileInfo}
                        </Col>
                        <Col sm={8} md={8}>
                            {rightPanel}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/profile.js